var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareWhatsapp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 45,
    y1: 90,
    x2: 45,
    gradientTransform: "translate(23.93 -15.05) rotate(25.67)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#23cf43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ffb7d"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    transform: "translate(-15.05 23.93) rotate(-25.67)",
    fill: "url(#a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.11,23.1A29.73,29.73,0,0,0,20.32,59L16.1,74.36l15.76-4.13a29.77,29.77,0,0,0,14.21,3.62h0a29.73,29.73,0,0,0,21-50.75Zm-21,45.73h0a24.59,24.59,0,0,1-12.58-3.45l-.9-.53L23.24,67.3l2.49-9.11-.58-.94A24.71,24.71,0,1,1,46.08,68.83Zm13.55-18.5h0c.74.37,1.24.56,1.43.87a6.28,6.28,0,0,1-.44,3.53C60,56.46,57,58,55.61,58.26a10.15,10.15,0,0,1-4.68-.3A42.9,42.9,0,0,1,46.7,56.4C39.24,53.18,34.38,45.68,34,45.19s-3-4-3-7.68a8.33,8.33,0,0,1,2.6-6.2,2.75,2.75,0,0,1,2-.93c.5,0,1,0,1.43,0s1.07-.18,1.67,1.27,2.1,5.14,2.29,5.52A1.37,1.37,0,0,1,41,38.5a5.43,5.43,0,0,1-.74,1.24c-.37.43-.78,1-1.12,1.3s-.76.77-.32,1.51A22.08,22.08,0,0,0,43,47.7a20.25,20.25,0,0,0,6,3.68c.75.37,1.18.31,1.61-.18s1.86-2.17,2.35-2.92,1-.61,1.68-.37S58.89,50,59.63,50.33Z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareWhatsapp);
export default __webpack_public_path__ + "static/media/share-whatsapp.bf82c4e4b0e1ea5902c41fe11f3654c7.svg";
export { ForwardRef as ReactComponent };